require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-tags-bryce-deeney.json") })
        }
      }, "path---es-articles-tags-bryce-deeney");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-tags-bryce-deeney!./.cache/json/es-articles-tags-bryce-deeney.json
// module id = 2276
// module chunks = 231608221292675